<template>
  <div class="bg-white px-[24px] py-[32px] mt-[16px] rounded-[4px]">
    <h1 class="text-[16px] font-normal leading-[19.36px] text-[#353535]">
      All Activities
    </h1>
    <div class="w-full">
      <div>
        <span v-if="isActivityLoading" class="fa-solid fa-spinner fa-spin">
        </span>
        <div v-else class="mt-[16px]">
          <div v-for="(activity, index) in activities" :key="activity.id" class="flex items-start relative">
            <div class="mr-3 relative">
              <div
                class="bg-transparent border-blue-500 border-solid border-[1.5px] rounded-full z-10 relative p-[5px]">
                <div class="w-2 h-2 rounded-full bg-blue-500"></div>
              </div>
              <div v-if="index < activities.length - 1"
                class="absolute top-[19px] left-[8px] w-[1.5px] h-[100%] bg-[#96A0B5]"></div>
            </div>
            <!-- {{ activity }} -->
            <p class="text-[14px] font-normal leading-[24px] text-[#353535]"
              :class="{ 'mb-[14px]': index < activities.length - 1 }">
              {{ activity.actionName }} by {{ activity.performedBy }} on
              {{
                activity.actionName.toLowerCase().includes("stage")
                  ? formatDate(activity.actionDate)
                  : formatDate(activity.date)
              }}.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  props: ["purchaseId"],
  data() {
    return {
      isActivityLoading: false,
      activities: [],
      orderId: "",
    };
  },
  mounted() {
    this.getActivies();
  },
  methods: {
    async getActivies() {
      this.isActivityLoading = true;
      try {
        const response = await this.$http.get(
          `/Activity/${this.purchaseId}/${1}`
        );
        if (response.ok) {
          this.activities = response.body;
        }
        this.isActivityLoading = false;
      } catch (error) {
        console.log(error);
        this.isActivityLoading = false;
      }
    },
    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },
  },
};
</script>
